import { FunctionComponent, PropsWithChildren, useContext } from "react";
import { FloatingPanelMenuContext } from "./FloatingPanelMenu.context";
import { IFloatingPanelMenuTriggerProps } from "./interfaces/IFloatingPanelMenuTriggerProps";

export const FloatingPanelMenuTrigger: FunctionComponent<PropsWithChildren<IFloatingPanelMenuTriggerProps>> = (props) => {
    const floatingPanelContext = useContext(FloatingPanelMenuContext);

    if (floatingPanelContext === undefined) {
        throw new Error("Can't use FloatingPanelMenuTrigger component outside of FloatingPanelMenu component.");
    }

    const { model, events, contentId } = floatingPanelContext;

    const isDisabled = props.isDisabled === true;
    const isOpen = model.isOpen && !isDisabled;
    const className = `${props.className !== undefined ? props.className : ""} ${isOpen && props.activeClass !== undefined ? props.activeClass : ""}`;

    return (
        <button
            ref={floatingPanelContext.triggerRef}
            aria-controls={contentId}
            aria-expanded={model.isOpen}
            aria-haspopup={true}
            aria-label={props.ariaLabel}
            aria-disabled={isDisabled}
            disabled={isDisabled}
            className={className}
            data-hook={props.dataHook}
            id={props.id}
            type="button"
            onClick={events.trigger.onClick}
            onKeyDown={(e) => events.trigger.onKeyDown(e, floatingPanelContext.items)}
            onMouseDown={events.trigger.onMouseDown}>
            {props.children}
        </button>
    );
};
